<template>
  <div class="TQ_center">

    <div class="TQ_inline TQ_margin_8px TQ_width_100p TQ_maxWidth_350px TQ_padding_8px TQ_borderBox "
         :style="{'direction' : helper_getDirectionByLangCode_fe(langCode)}"
         v-for="langCode in pb_qex_langArr_ae">

      <div class="TQ_text_24px"> {{format_langCode(langCode)}} </div>

      <!--<tq-textarea-->
      <!--:pb_uid_s="pb_uid_s"-->
      <!--pb_textarea-class_s="TQ_text_16px TQ_box_shadow TQ_padding_8px"-->

      <!--:pb_init-text_s="pb_creatorTerms_blc_s[langCode]"-->
      <!--:pb_max-length_n="400"-->
      <!--:pb_placeholder_s="ass_strings.twoWords_creatorTerms[langCode]"-->
      <!--:pb_rows_n="20"-->
      <!--:pe_change-text_s="(text_s) => {pb_creatorTerms_blc_s[langCode] = text_s}"-->
      <!--/>-->

      <tq-wysiwyg-editor :id="pb_uid_s"
                         :file-name="pb_uid_s + '_creatorTerms_' + langCode"
                         :p_value_html="pb_creatorTerms_blc_c[langCode].w_body_s"
                         :pe_update-value_f="(newValue_html) => {pb_creatorTerms_blc_c[langCode].w_body_s = newValue_html}"
                         :pe_choose-file_f="pe_chooseFile_f"
                         height="200px"/>
    </div>

  </div>
</template>

<script>
    import { FB_Wysiwyg} from "../../../../../functions/src/shareCode/Share_S_Classes";
    import {format_langCode_fs} from "../../../../../functions/src/shareCode/Share_S_Format";
    import {enum_langCodes} from "../../../../../functions/src/shareCode/Share_S_Enum";
    import TqCard from "../../../../components/basic/TqCard";
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {helper_getDirectionByLangCode_fe} from "../../../../scripts/S_Helper";
    import {
        validator_enum_array_fb,
        } from "../../../../../functions/src/shareCode/Share_S_Validator";
    import TqTextarea from "../../../../components/basic/TqTextarea";
    import TqWysiwygEditor from "../../../../components/complex/TqWysiwygEditor";
    import {validator_objClass_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import {enum_typeof} from "../../../../../functions/src/shareCode/Share_S_Enum";

    export default {

        name: "C_Creator_EditQuests_Item_Explore_creatorTerms",
        components:{
            TqWysiwygEditor,
            TqTextarea,
            TqCard,
        },
        props:{
            pb_uid_s:{
                type:String,
                require: true
            },
            pb_creatorTerms_blc_c :{
                type : Object,
                require: true,
                validator(obj){
                    return validator_objClass_fb(obj, FB_Wysiwyg)
                }
            },
            pb_qex_langArr_ae :{
                type: Array,
                require: true,
                validator(arr){
                    return validator_enum_array_fb(enum_langCodes,arr)
                }
            },
            pe_chooseFile_f : {},
        },
        data(){
            return{
                ass_strings : ass_strings,
                format_langCode : format_langCode_fs,
                helper_getDirectionByLangCode_fe : helper_getDirectionByLangCode_fe
            }
        },


    }
</script>

<style scoped lang="scss">








</style>
